<template>
  <a-row>
    <a-row class="content-title" type="flex">
      <h2>Статистика</h2>
    </a-row>
    <statistics-table />
  </a-row>
</template>

<script>
export default {
  components: {
    "statistics-table": () =>
      import("@/components/statistics/statistics-table.vue")
  }
}
</script>

<style></style>
